module.exports = __webpack_public_path__ + "media/images/emblems/Rochefort-NE-blason-b0c418eed51b8ab09b23995b6bbadb50.png";